import _ from 'lodash';

import { MaritalStatusType } from 'constants/loanApplication';
import { getPersonFullName } from 'utils/loanApplication';

import { SPOUSE_TYPE } from '../../MainContent.constants';

export const getNbeOptionsFromForm = ({
  applicationData,
  form,
  entityId,
  currentEntitySpouseValue,
}) => {
  const nbeOptionsSource = Object.entries(_.omit({ ...applicationData, ...form }, entityId));

  return nbeOptionsSource.reduce((acc, [id, nbe]) => {
    const isMarried =
      nbe.maritalStatus === MaritalStatusType.MARRIED ||
      nbe.maritalStatus?.value === MaritalStatusType.MARRIED;
    const hasRelationship = !!nbe.relation;
    const isSpouseOfCurrentNbe =
      hasRelationship &&
      (nbe.relation === currentEntitySpouseValue ||
        nbe.relation?.value === currentEntitySpouseValue);

    if (isMarried && hasRelationship && !isSpouseOfCurrentNbe) {
      return acc;
    }

    const option = {
      name: getPersonFullName(nbe),
      value: `${SPOUSE_TYPE.NON_BORROWER}${applicationData[id].order}`,
      id,
      type: SPOUSE_TYPE.NON_BORROWER,
    };
    acc.push(option);

    return acc;
  }, []);
};

export const getNbeOptionsFromTableData = ({ nonBorrowers }) => {
  return (nonBorrowers ?? []).reduce((acc, nbe) => {
    const hasSpouse = !!nbe.spouse?.type;

    if (hasSpouse) {
      return acc;
    }

    const option = {
      name: nbe.fullName,
      value: `${SPOUSE_TYPE.NON_BORROWER}${nbe.orderNumber}`,
      id: nbe.id,
      type: SPOUSE_TYPE.NON_BORROWER,
    };
    acc.push(option);

    return acc;
  }, []);
};
